export const setPreferredClassGroup = (classGroupId: number | string) =>
  localStorage.setItem('persistedClassGroupId', classGroupId.toString())
